import { FilterDto, FilterType } from '../../../types/FilterDto';
import { getFilters } from '../../admin/Dictionaries/api/basicGenericTable';
import { ClaimStatusEnum } from '../types/ClaimStatusEnum';
import type { TFunction } from "i18next";
import { TimelineStatusEnum } from '../types/enums';
import { getRequestTypesByClient } from '../../admin/claimRequestType/api/claimRequestTypeApi';
import { getClaimFilters } from './ClaimAPI';

export const getFiltersClaims = async (t: TFunction<[string], undefined>): Promise<FilterDto[]> => {
    const claimFilters: FilterDto[] = await getClaimFilters();
    
    const serviceIndicatorsFilter: FilterDto = await getFilters("serviceIndicators");
    const claimRequestTypes = await getRequestTypesByClient();
    serviceIndicatorsFilter.values = [
        { key: -1, value: t("dashboard:filters.withoutService") },
        ...(serviceIndicatorsFilter.values ?? [])
    ];
    serviceIndicatorsFilter.description = t ? t("dashboard:filters.ServiceIndicators"): "ServiceIndicators";

    const staticFilters: FilterDto[] = [
        {
            name: 'EntryDate',    
            description: t("claim:newClaimInputOacEntryDate"),
            type: FilterType.DATE,
            values: []
        },
        {
            name: 'CreatedDate',    
            description:t("claim:newClaimInputCreationDate"),
            type: FilterType.DATE,
            values: []
        },
        {
            name: 'EventDate',
            description: t("claim:newClaimInputEventDate"),
            type: FilterType.DATE,
            values: []
        },
        {
            name: 'ClosingDate',    
            description: t("claim:newClaimInputClosingDate"),
            type: FilterType.DATE,
            values: []
        },
        {
            name: 'Status',
            description: t("dashboard:filters.Estat"),
            type: FilterType.MULTIPLE,
            values: Object.keys(ClaimStatusEnum)
                .filter((key) => isNaN(Number(key)) && key !== ClaimStatusEnum[ClaimStatusEnum.Cancelled])
                .map((value) => ({
                    key: ClaimStatusEnum[value as keyof typeof ClaimStatusEnum],
                    value: t(`claim:status.${value}`)
                }))
        },
        {
            name: 'Timeline',
            description: t("claim:filters.timeline"),
            type: FilterType.MULTIPLE,
            values: Object.keys(TimelineStatusEnum)
                .filter((key) => isNaN(Number(key)))
                .map((value) => ({
                    key: TimelineStatusEnum[value as keyof typeof TimelineStatusEnum],
                    value: t(`claim:timelineStatus.${value}`)
                }))
        },
        {
            name: 'RequestTypeId',
            description: t("claim:filters.type"),
            type: FilterType.MULTIPLE,
            values: claimRequestTypes.map((rt) => ({
                key: rt.id,
                value: rt.name
            }))
        }
    ];

    return [...staticFilters, ...claimFilters, serviceIndicatorsFilter];
};
